module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Strikethrough-e66bc3607102c94ae0e6006ab6e5f54f.svg";